import { Button, Chip, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Stack, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CloseLineIcon } from '../../components/IconComponent'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next';
import { TextFieldCustom } from '../../components/FormElements';
import validators from '../../utils/validators';
export default function RemoveDeviceInputView(props) {
    const { activity, device } = props;
    const { t } = useTranslation();
    const { palette } = useTheme();

    const renderState = (state) => {
        let label = t(state);
        let color = state == 'PENDING' ? 'warning' : 'success'
        return <Chip label={label} variant='customOutlined' size='small' color={color} />
    }

    return (
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <Dialog
                        open={props.isOpen}
                        onClose={props.onClose}
                        fullWidth={true}
                        maxWidth={"md"}
                        sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}
                    >
                        <Stack width={'100%'} height={60} flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} paddingX={2}>
                            <IconButton onClick={() => props.onClose()}>
                                <CloseLineIcon />
                            </IconButton>
                            <Typography variant='body1' marginLeft={1} marginRight={1}>{"Activity " + activity.name}</Typography>
                            <Chip label={activity.type.name} variant='customOutlined' size='small' sx={{ backgroundColor: activity.type.colour, color: "#FFFFFF", marginRight: 1 }} />
                            {renderState(activity.states[0].state)}
                        </Stack>
                        <DialogContent dividers={true} sx={{
                            padding: '0px 0px'
                        }}>
                            <Grid item xs={12} margin={2}>
                                <Field
                                    name="removedSerial"
                                    component={TextFieldCustom}
                                    label={t('device_removed')}
                                    placeholder={t('enter_removed_device')}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.required)}
                                    autoFocus={true}
                                />
                            </Grid>

                        </DialogContent>
                        <DialogActions>
                            <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                                <Button sx={{ marginRight: 2 }} variant='contained' onClick={handleSubmit} type='submit'>{t('next')}</Button>
                            </Grid>
                        </DialogActions>
                    </Dialog >
                </form>)}
        />

    )
}
